import React from 'react';
import track from '~/mixpanel-service';

export const usePrintTracker = () => {
    React.useEffect(() => {
        const afterPrint = () => {
            // Emit an event to Mixpanel when the page print dialog is closed.
            // The current page path is retrieved using window.location.pathname
            //  instead of useLocation, since useLocation only captures the path at the initial mount.

            // The regex replaces all occurrences of /<number> with /x in the path.
            track('print', 'page-printed', { url: window.location.pathname.replace(/\/\d+/g, '/x') });
        };

        window.addEventListener('afterprint', afterPrint);

        return () => {
            window.removeEventListener('afterprint', afterPrint);
        };
    }, []);
};
